


















































































































































import {mdiDownload} from '@mdi/js';
import {Component, Vue} from 'vue-property-decorator';

import History from '@/components/elements/statement/History.vue';
import ResultView from '@/components/elements/statement/ResultView.vue';
import {deleteStatement, repeatSendPackage} from '@/api/statements';
// eslint-disable-next-line no-unused-vars
import {IStatementStatusInfo} from '@/utils/types';
import {mapStatementName} from '@/utils/services';
import {ErrorAlertModule} from '@/store/modules/errors';
import {RouteName} from '@/router';
// eslint-disable-next-line no-unused-vars
import {StatementType} from '@/types/services';
import {createCopy} from '@/api/statements';
import {AuthModule} from '@/store/modules/auth';
import ConfirmationModalView from '@/components/base/ConfirmationModalView.vue';
import {StatementStatusInfoModule} from '@/store/modules/statementStatusInfo';

import AltDocumentsPaymentButton
  from '@/components/profile/statements/statementDetailButton/AltDocumentsPaymentButton.vue';
import AddDocumentsBtn from '@/components/profile/statements/statementDetailButton/AddDocumentsBtn.vue';
import AltDistrictButton from '@/components/profile/statements/statementDetailButton/AltDistrictButton.vue';
import AltWithdrawnButton from '@/components/profile/statements/statementDetailButton/AltWithdrawnButton.vue';
import AdditionalSignerButton from '@/components/profile/statements/statementDetailButton/AdditionalSignerButton.vue';
import ResendToFsspBtn from './statementDetailButton/ResendToFsspBtn.vue';
import {errorHandler, makeFirstLetterUppercase} from '@/utils/common';
import {StatementStatus} from '@/utils/statementStatus';
import SurchargeBtn from './statementDetailButton/SurchargeBtn.vue';

@Component({
  components: {
    ConfirmationModalView,
    History,
    ResultView,
    AddDocumentsBtn,
    AltDocumentsPaymentButton,
    AltDistrictButton,
    AltWithdrawnButton,
    AdditionalSignerButton,
    ResendToFsspBtn,
    SurchargeBtn,
  },
  data: () => ({
    mdiDownload,
    tab: 0,
    status: {},
  }),
})
export default class StatementDetail extends Vue {
  private status!: IStatementStatusInfo | any;
  private history: any[] = [];
  private statementId!: string;
  private statementType!: StatementType;
  private statementName: string = '';
  private showDialogDelete: boolean = false;
  loading = false;
  loadedGetStatus = false;

  get title() {
    return this.status.extId
        ? `${this.statementName} ${this.status.extId}`
        : this.statementName;
  }

  get userIsCreator() {
    // Создатель заявления, данный пользователь
    return this.status.userIsCreator;
  }

  get withAdditionalSigners() {
    return Boolean(this.status?.additionalSigners?.length);
  }

  get formattingStatusHistory() {
    const data = this.status;
    data.statusHistory = this.status.statusHistory?.map((item: any) => {
      if (
          // eslint-disable-next-line no-prototype-builtins
          !item.hasOwnProperty('customParameters') ||
          (Object.keys(item.customParameters).length === 0 &&
              item.customParameters.constructor === Object)
      ) {
        item.customParameters = null;
      } else if (
          // eslint-disable-next-line no-prototype-builtins
          item.hasOwnProperty('customParameters') &&
          this.isEmptyCustomParameters(item.customParameters)
      ) {
        item.customParameters = null;
      } else if (
          Object.prototype.hasOwnProperty.call(item, 'customParameters') &&
          !this.isEmptyCustomParameters(item.customParameters) &&
          [
            StatementStatus.AWAITING_PAYMENT,
            StatementStatus.SUSPENDED_DOCUMENTS_PROVIDED,
          ].includes(item.statusCode)
      ) {
        item.customParameters = this.createAwaitingPaymentStatusResponse(
            item.customParameters
        );
      } else if (
          Object.prototype.hasOwnProperty.call(item, 'customParameters') &&
          !this.isEmptyCustomParameters(item.customParameters) &&
          item.statusCode === StatementStatus.SENT_TO_FSSP
      ) {
        item.customParameters = this.createSentToFsspStatusResponse(
            item.customParameters
        );
      }
      return item;
    });
    return data;
  }

  get isSurcharge() {
    return Boolean(this.status?.parentSurchargeId);
  }

  createAwaitingPaymentStatusResponse(data: any) {
    let res: any = {
      fio: `${makeFirstLetterUppercase(data.surname) ?? null} ${
          makeFirstLetterUppercase(data.firstname) ?? null
      } ${makeFirstLetterUppercase(data.patronymic) ?? null}`,
      address: data.address ?? null,
      inn: data.inn ?? null,
      purpose: data.purpose ?? null,
      chargePayTillDate: data.chargePayTillDate ?? null,
      chargeAmount: {
        value: +data.chargeAmount ?? null,
        list: {
          price: data.price ? +data.price : null,
          multiplier: data.multiplier ? +data.multiplier : null,
          privilegesName: data.privilegesName ? data.privilegesName : null,
          privilegesDiscount:
              data.privilegesDiscount && data.privilegesDiscount > 0
                  ? `Скидка ${data.privilegesDiscount}%`
                  : null,
        },
      },
      reason: data.reason ?? null,
      assistantSurname: makeFirstLetterUppercase(data.assistantSurname) ?? null,
      assistantFirstname:
          makeFirstLetterUppercase(data.assistantFirstname) ?? null,
      assistantPatronymic:
          makeFirstLetterUppercase(data.assistantPatronymic) ?? null,
      assistantInn: data.assistantInn ?? null,
    }
    if (data.additionalPaymentInfos && JSON.parse(data.additionalPaymentInfos).length > 0) {
      try {
        res.additionalPaymentInfos = JSON.parse(data.additionalPaymentInfos).map((val: any) => {
          val = {
            checkingAccount: val.checkingAccount ?? null,
            bik: val.bik ?? null,
            correspondentAccount: val.correspondentAccount ?? null,
            bankName: val.bankName ?? null,
            SBPBankName: val.sbpbankName ?? null,
            SBPBankId: val.sbpbankId ?? null,
            SBPPhone: val.sbpphone ?? null,
          }
          return val
        })
      } catch (e) {
        console.error(e)
      }
    }
    res = {
      ...res,
      checkingAccount: data.checkingAccount ?? null,
      bik: data.bik ?? null,
      correspondentAccount: data.correspondentAccount ?? null,
      bankName: data.bankName ?? null,
      SBPBankName: data.SBPBankName ?? null,
      SBPBankId: data.SBPBankId ?? null,
      SBPPhone: data.SBPPhone ?? null,
    }

    return res;
  }

  createSentToFsspStatusResponse(data: any) {
    return {
      ...data,
      tariff: Number(data.tariff) ?? null,
      th: Number(data.th) ?? null,
      total: Number(data.total) ?? null,
    };
  }

  isEmptyCustomParameters(customParameters: any) {
    let nonEmptyCount = 0;
    if (customParameters) {
      for (let item in customParameters) {
        if (customParameters[item] !== '') nonEmptyCount++;
      }
    }
    return nonEmptyCount === 0;
  }

  async mounted() {
    await this.getData();
  }

  async getData() {
    this.statementId = this.$route.params.id;
    await StatementStatusInfoModule.get(this.statementId);
    this.loadedGetStatus = StatementStatusInfoModule.loaded;
    if (!this.loadedGetStatus) return;
    this.status = StatementStatusInfoModule.entity;
    this.history = this.status.statusHistory;
    this.statementType = this.status.statementType;
    this.statementName = mapStatementName[this.statementType];
  }

  setTest() {
    this.statementType = StatementType.NOTICE_RECOVERY;
  }

  goToEdit() {
    if (this.statementType) {
      this.$router.push({
        name: RouteName[this.statementType],
        params: {statementId: this.statementId},
      });
    }
  }

  goDetails() {
    this.$router.push({
      name: RouteName.FORM_VIEW,
      params: {statementId: this.statementId},
    });
  }

  onDialogOk() {
    this.btnDeleteClickHandler();
  }

  onDialogCancel() {
    this.showDialogDelete = false;
  }

  async btnDeleteClickHandler() {
    this.loading = true;
    ErrorAlertModule.setErrorAlert('');

    try {
      await deleteStatement(this.statementId);
      await this.$router.push({name: RouteName.STATEMENTS});
    } catch (error) {
      errorHandler(error);
    }

    this.loading = false;
  }

  async createCopyStatement() {
    const {statementType, id} = await createCopy(this.statementId);
    if (AuthModule.isAuthenticated) {
      await this.$router.push({
        name: RouteName[statementType as StatementType],
        params: {statementId: id},
      });
    } else {
      await this.$router.push({name: 'login'});
    }
  }

  async repeatSendPackage() {
    try {
      await repeatSendPackage(this.statementId);
      this.$toast.success('Заявление отправлено повторно');
    } catch (e) {
      this.$toast.error(e.response.data.errorString);
    }
    await this.getData();
  }
}
